/* eslint-disable react/require-default-props */
import React from 'react';
import { FileSectionRow, Section } from '../../interfaces';
import CustomerTransactionsSection from './CustomerTransactionsSection';
import PaymentSection from './PaymentSection';
import SectionHeader from './SectionHeader';
import SectionPhoneRow from './SectionPhoneRow';
import SectionTextRow from './SectionTextRow';
import TransactionsSection from './TransactionsSection';
import CheckoutTransactionsSection from './CheckoutTransactionsSection';
import AppointmentTransfersSection from './AppointmentTransfersSection';
import CheckoutTransfersSection from './CheckoutTransfersSection';
import SectionComponentRow from './SectionComponentRow';
import { cx } from '../../helpers/global';
import SectionFileRow from './SectionFileRow';
import SectionColorRow from './SectionColorRow';
import SectionLinkRow from './SectionLinkRow';

type Props = Section & {
  modalName: string;
};

export default function SideBarSection({
  name,
  rows,
  modalName,
  values,
  buttonText,
  buttonAction,
  noGap,
}: Props) {
  return (
    <div className={cx('sidebar-section', noGap && 'no-gap')}>
      <SectionHeader
        name={name}
        buttonText={buttonText}
        buttonAction={buttonAction}
      />
      {name === 'Payment' && (
        <PaymentSection
          action={values.checkoutAction}
          refreshModal={values.refreshModal}
          appointment={values.appointment}
          key={`${modalName}-payment`}
        />
      )}
      {name === 'Appointment Transactions' && (
        <TransactionsSection appointment={values.appointment} />
      )}
      {name === 'Transfer Details' && (
        <AppointmentTransfersSection
          payment={values?.payment}
          appointment={values.appointment}
        />
      )}
      {name === 'Checkout Transactions' && (
        <CheckoutTransactionsSection paymentsGroup={values.paymentsGroup} />
      )}
      {name === 'Checkout Transfer Details' && (
        <CheckoutTransfersSection paymentsGroup={values.paymentsGroup} />
      )}
      {name === 'Customer Transactions' && (
        <CustomerTransactionsSection customer={values.customer} />
      )}
      {name !== 'Payment' &&
        name !== 'Appointment Transactions' &&
        name !== 'Transfer Details' &&
        rows.map(sectionRow => {
          if (!sectionRow.value?.[0]) return null;
          return (
            <React.Fragment
              key={
                sectionRow.id ||
                (
                  sectionRow.label +
                  sectionRow.type +
                  sectionRow.value[0]
                ).toString()
              }>
              {sectionRow.type === 'IMAGE' && (
                <SectionFileRow
                  label={sectionRow.label}
                  values={(sectionRow.value as string[])?.map(url => ({
                    id: url,
                    url,
                    name: 'url',
                    type: 'image',
                  }))}
                  key={`${modalName}-${sectionRow.label}`}
                />
              )}
              {sectionRow.type === 'TEXT' && (
                <SectionTextRow
                  label={sectionRow.label}
                  values={sectionRow.value as string[]}
                  key={`${modalName}-${sectionRow.label}`}
                />
              )}
              {sectionRow.type === 'LINK' && (
                <SectionLinkRow
                  label={sectionRow.label}
                  values={sectionRow.value as string[]}
                  key={`${modalName}-${sectionRow.label}`}
                />
              )}
              {sectionRow.type === 'PHONE' && (
                <SectionPhoneRow
                  label={sectionRow.label}
                  values={sectionRow.value as string[]}
                  key={`${modalName}-${sectionRow.label}`}
                />
              )}
              {sectionRow.type === 'NODE' && (
                <SectionComponentRow
                  label={sectionRow.label}
                  values={sectionRow.value?.[0] as React.ReactNode}
                  key={`${modalName}-${sectionRow.label}`}
                />
              )}
              {sectionRow.type === 'FILE' && (
                <SectionFileRow
                  label={sectionRow.label}
                  values={(sectionRow as FileSectionRow).value}
                  key={`${modalName}-${sectionRow.label}`}
                />
              )}
              {sectionRow.type === 'COLOR' && (
                <SectionColorRow
                  label={sectionRow.label}
                  values={sectionRow.value as string[]}
                />
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
}
